import { RealTimeModule } from './pages/real-time/real-time.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';

import { environment } from '../environments/environment';

import { HomeModule } from './pages/home/home.module';
import { PagesModule } from './pages/pages.module';

import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { AppEffects } from './core/state/app.effects';
import { reducer } from './core/state/app.reducer';

import { ComponentsModule } from './components/components.module';

import { AppRoutingModule } from './app-routing.module';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { AppComponent } from './app.component';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
PlotlyModule.plotlyjs = PlotlyJS;

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		// Other Modules
		BrowserAnimationsModule,
		ToastrModule.forRoot(),
		ReactiveFormsModule,
		AppRoutingModule,
		HttpClientModule,
		ComponentsModule,
		BrowserModule,
		PagesModule,
		FormsModule,
		HomeModule,
		PlotlyModule,
		TagCloudModule,
		RealTimeModule,

		// NgRx Modules
		StoreModule.forRoot({
			authContext: reducer,
		}),
		EffectsModule.forRoot([AppEffects]),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: environment.production,
		}),
		NgbModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		AuthGuardService,
	],
	exports: [],
	bootstrap: [AppComponent],
})
export class AppModule {}
